import { Trans } from "@lingui/react/macro"
import { createFileRoute } from "@tanstack/react-router"
import { ShieldX, RefreshCw } from "lucide-react"
import { Button } from "@/components/ui/button"

export const Route = createFileRoute("/(authenticated)/no-access")({
  component: RouteComponent,
})

function RouteComponent() {
  const handleRefresh = () => {
    window.location.reload()
  }

  return (
    <div className="mx-auto w-full max-w-7xl px-4 py-4 sm:px-6 sm:py-6">
      <div className="flex min-h-[60vh] flex-col items-center justify-center">
        <div className="mx-auto max-w-md text-center">
          <ShieldX className="mx-auto mb-6 h-16 w-16 text-neutral-400" />

          <h1 className="mb-2 text-2xl font-semibold">
            <Trans>No Access</Trans>
          </h1>

          <p className="mb-6 text-neutral-600 dark:text-neutral-400">
            <Trans>
              Your account is awaiting role assignment. Please contact your administrator to grant
              access to the system.
            </Trans>
          </p>

          <div className="rounded-lg border border-neutral-200 bg-neutral-50 p-4 dark:border-neutral-800 dark:bg-neutral-900">
            <p className="text-sm text-neutral-600 dark:text-neutral-400">
              <Trans>
                Once an administrator assigns you a role, click the button below to refresh and
                access the system.
              </Trans>
            </p>
          </div>

          <Button onClick={handleRefresh} className="mt-6" variant="outline">
            <RefreshCw className="mr-2 h-4 w-4" />
            <Trans>Refresh Access</Trans>
          </Button>

          <p className="mt-6 text-sm text-neutral-500">
            <Trans>Need help? Contact your system administrator.</Trans>
          </p>
        </div>
      </div>
    </div>
  )
}
